// Vendors
import React, { useState } from 'react';
import { Panel } from 'react-instantsearch-dom';
import classnames from 'classnames';
import AnimateHeight from 'react-animate-height';

// Components
import { RefinementList } from '..';

const Facet = ({ id, title, attribute }) => {
  const [refinementShow, setRefinementShow] = useState(true);
  const panelClassNames = classnames('resource-sidebar__title', {
    [`toggle__switch--on`]: refinementShow
  });

  return (
    <Panel id={`facets-${id}`} className="resource-sidebar__facet">
      <h6
        className={panelClassNames}
        onClick={() => setRefinementShow(!refinementShow)}
      >
        {title}
        <span className="caret" />
      </h6>
      <AnimateHeight
        duration={300}
        height={refinementShow ? 'auto' : 0}
        easing={'ease-in-out'}
      >
        <div className="form__field">
          <RefinementList
            attribute={`facets.${attribute}`}
            showMore={true}
            operator="or"
            transformItems={(items) =>
              items.sort((a, b) => {
                const labelA = a.label.toUpperCase();
                const labelB = b.label.toUpperCase();
                return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
              })
            }
          />
        </div>
      </AnimateHeight>
    </Panel>
  );
};

export default Facet;
